import { ADMIN_TASK_IDS, type AdminTaskId } from "@/shared/constants/taskIds";

export interface AdminStepDef {
  number: number;
  title: string;
  description: string;
  taskId: AdminTaskId;
}

export const ADMIN_STEPS: AdminStepDef[] = [
  {
    number: 1,
    title: "Confirm no valid will",
    description:
      "Before the court appoints an administrator, it needs to know there's no valid will. A few questions now help keep your filing from being sent back.",
    taskId: ADMIN_TASK_IDS.WILL_SEARCH,
  },
  {
    number: 2,
    title: "Review family members",
    description:
      "Identify all legal distributees (heirs-at-law). Under NY administration, every legal heir must be formally listed regardless of family dynamic.",
    taskId: ADMIN_TASK_IDS.FAMILY_TRIAGE,
  },
  {
    number: 3,
    title: "Confirm administrator",
    description:
      "Choose who will apply to the court for Letters of Administration. Higher-priority relatives must consent or step aside.",
    taskId: ADMIN_TASK_IDS.CONFIRM_ADMIN,
  },
  {
    number: 4,
    title: "Family sign-offs",
    description:
      "Gather required Waivers of Process and Consent to Appointment from eligible family members so the court can grant Letters of Administration without a formal hearing.",
    taskId: ADMIN_TASK_IDS.FAMILY_SIGNOFFS,
  },
  {
    number: 5,
    title: "Get your administration forms",
    description:
      "We generate the petition, affidavits, and supporting forms pre-filled with everything you confirmed, ready for the courthouse.",
    taskId: ADMIN_TASK_IDS.FORMS_PACKET,
  },
];

export const ADMIN_STEP_TASK_IDS = ADMIN_STEPS.map((s) => s.taskId);
